import { BackendOption } from '~/models/shared/types'
import { Geolocation } from '~/models/common/types'

export interface ClassifiedRentalInfo {
  averagePricePerDay: string
  totalDays: number
  priceForPeriod: string
  priceAfterDiscount?: string
  isAvailableForDays?: boolean
}

export interface ClassifiedExtraRentalService {
  name: string
  payment: ClassifiedExtraRentalServicePayment
  price: number
  value: string
}

export interface ClassifiedExtraRentalServicePayment {
  name: string
  value: Payment
}

export enum Payment {
  FREE = 'free',
  ONE_TIME = 'one_time',
  DAILY = 'daily'
}

export interface ClassifiedRentalInsurance {
  hasMixedInsuranceOption: boolean
  baseInsurancePackage: BackendOption[]
}

export interface ClassifiedRentalPickupLocation {
  geolocation: Geolocation
  postcode: string
  address: string
}
